export default function loadingButton(btn) {
    let loadingIcon
    let el = btn

    if (!el) {
        el = document.createElement('button')
    }

    el.insertAdjacentHTML('beforeend', getSvgMarkup())
    loadingIcon = el.querySelector('.js-loading-icon')

    return {
        el,
        startLoading: startLoading,
        stopLoading: stopLoading
    }
}

function getSvgMarkup() {
    return `<div class="u-btn__loading-icon js-loading-icon">
        <div class="u-btn__icon-wrap">
            <svg>
                <use xlink:href="/application/themes/the_escape/assets/images/svgicons.svg#oval"></use>
            </svg>
        </div>
    </div>`
}

function startLoading() {
    this.el.classList.add('is-loading')
}

function stopLoading() {
    this.el.classList.remove('is-loading')
}
